module.exports = __webpack_public_path__ + "img/9788901081977.47318113.jpg";